import {
  compose,
  withProps
} from 'recompose'

import SpecialToolsPage from '../components/SpecialTools'
import { withInitialData } from '../components/hoc'

export default compose(
  withProps({
    title: '',
    contentImage: ''
  }),
  withInitialData
)(SpecialToolsPage)



// WEBPACK FOOTER //
// ./pages/special-tools.js